import { Component, OnInit } from '@angular/core';
import { Caixa } from 'src/app/base/domain/caixa.model';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { DialogService } from 'src/app/global/services/dialog.service';
import { CaixaService } from 'src/app/base/services/caixa.service';
import { ReturnAPI, Page } from 'src/app/base/domain/return-api.model';
import { CaixaAcaoEvent, CaixaListFilterOptions } from 'src/app/global/lists/caixa-list/caixa-list.component';
import { ValoresCaixaRequestDTO } from 'src/app/base/domain/dto/valores-caixa-request.dto';
import { TipoCaixa } from 'src/app/base/domain/enum/tipo-caixa.enum';
import { ContaTev } from 'src/app/base/domain/conta-tev.model';
import { LancamentoDespesa } from 'src/app/base/domain/lancamento-despesa.model';
import { Posto } from 'src/app/base/domain/posto.model';
import { DESCRICAO_FORMA_PAGAMENTO_DESPESA } from 'src/app/base/domain/enum/forma-pagamento-despesa.enum';
import {
  DESCRICAO_SITUACAO_LANCAMENTO_DESPESA,
  SituacaoLancamentoDespesa,
} from 'src/app/base/domain/enum/situacao-lancamento-despesa.enum';
import { ContaTevService } from 'src/app/base/services/conta-tev.service';
import { LancamentoDespesaService } from 'src/app/base/services/lancamento-despesa.service';
import { PostoService } from 'src/app/base/services/posto.service';
import {
  LancamentoDespesaAcaoEvent,
  LancamentoDespesaListFilterOptions,
} from 'src/app/global/lists/lancamento-despesa-list/lancamento-despesa-list.component';
import { LancamentoDespesaFormComponent } from 'src/app/global/forms/lancamento-despesa-form/lancamento-despesa-form.component';

/** Descreve uma coluna da planilha exportada. */
interface ColunaRelatorio {
  titulo: string;
  /** Largura em caracteres. */
  largura: number;
  valor: (lancamento: LancamentoDespesa) => string | number | Date;
  /** Formato numérico do Excel (data ou moeda). */
  formato?: string;
  /** Recebe o total dos lançamentos na última linha. */
  somar?: boolean;
}

@Component({
  selector: 'app-caixa-despesa-funcionario-main',
  templateUrl: './caixa-despesa-funcionario-main.component.html',
  styleUrls: ['./caixa-despesa-funcionario-main.component.css'],
})
export class CaixaDespesaFuncionarioMainComponent implements OnInit {
  private static IR_PARA_DETALHES_ACTION = 'Ir para Detalhes';
  private static EDITAR_LANCAMENTO_ACTION = 'Editar Lançamento';
  private static PAGAR_LANCAMENTO_ACTION = 'Marcar como Pago';
  private static CANCELAR_LANCAMENTO_ACTION = 'Cancelar Lançamento';
  private static MILISSEGUNDOS_POR_DIA = 24 * 60 * 60 * 1000;

  caixas: Caixa[] = [];
  queryOptions = new QueryOptions({ pageSize: 10 });
  totalRecords = 0;
  loading = false;
  type = 'cdef';
  totalizador: number;
  private postoSelecionado: number = null;

  lancamentos: LancamentoDespesa[] = [];
  queryOptionsLancamento = new QueryOptions({ pageSize: 10, pageSort: 'dataDespesa,desc' });
  totalRecordsLancamento = 0;
  loadingLancamento = false;
  totalizadorLancamento = 0;
  postos: Posto[] = [];
  contas: ContaTev[] = [];

  private readonly colunasRelatorio: ColunaRelatorio[] = [
    { titulo: 'Data', largura: 12, formato: 'dd/mm/yyyy', valor: (l: LancamentoDespesa) => this.paraSerialDoExcel(l.dataDespesa) },
    { titulo: 'Descrição', largura: 40, valor: (l: LancamentoDespesa) => l.descricao ?? '' },
    { titulo: 'Documento', largura: 18, valor: (l: LancamentoDespesa) => l.documento ?? '' },
    { titulo: 'Tipo de Despesa', largura: 18, valor: (l: LancamentoDespesa) => l.tipoDespesa ?? '' },
    { titulo: 'Categoria', largura: 20, valor: (l: LancamentoDespesa) => l.categoria ?? '' },
    {
      titulo: 'Forma de Pagamento',
      largura: 20,
      valor: (l: LancamentoDespesa) => DESCRICAO_FORMA_PAGAMENTO_DESPESA[l.formaPagamento] ?? '',
    },
    { titulo: 'Conta Bancária', largura: 30, valor: (l: LancamentoDespesa) => this.descricaoContaTev(l.contaTev) },
    { titulo: 'Posto', largura: 24, valor: (l: LancamentoDespesa) => l.postoDescricao ?? '' },
    { titulo: 'Valor', largura: 16, formato: 'R$ #,##0.00', somar: true, valor: (l: LancamentoDespesa) => l.valor ?? 0 },
    {
      titulo: 'Status',
      largura: 14,
      valor: (l: LancamentoDespesa) => DESCRICAO_SITUACAO_LANCAMENTO_DESPESA[l.situacao] ?? '',
    },
    {
      titulo: 'Data Pagamento',
      largura: 16,
      formato: 'dd/mm/yyyy',
      valor: (l: LancamentoDespesa) => this.paraSerialDoExcel(l.dataPagamento),
    },
    { titulo: 'Observação', largura: 40, valor: (l: LancamentoDespesa) => l.observacao ?? '' },
  ];

  constructor(private router: Router,
              public dialogService: DialogService,
              private caixaService: CaixaService,
              private activatedRoute: ActivatedRoute,
              public dialog: MatDialog,
              private lancamentoDespesaService: LancamentoDespesaService,
              private postoService: PostoService,
              private contaTevService: ContaTevService,
  ) {}

  ngOnInit(): void {
    this.queryOptions.params = {
      type: `${this.type}`,
      sort: '-dataHoraAbertura',
      ...this.activatedRoute.snapshot.queryParams
    };

    this.listarPostos();
    this.listarContas();
  }

  list(pageNumber: number = 0, valores: Partial<ValoresCaixaRequestDTO> = {}): void {
    this.queryOptions.pageNumber = pageNumber + 1;
    this.caixaService.pageAll(this.queryOptions).subscribe((response: ReturnAPI<Page<Caixa>>) => {
      if (response.success) {
        this.caixas = response.object.content;
        this.totalRecords = response.object.totalElements;
        this.mapearAcoes(response.object.content);
      } else {
        this.caixas = [];
        this.dialogService.feedbackReturnAPI(response, '');
      }

      valores.dataInicial = valores.dataInicial ? valores.dataInicial : null;
      valores.dataFinal = valores.dataFinal ? valores.dataFinal : null;

      this.getValorTotalPorTipoCaixa({ ...valores, postoId: this.postoSelecionado, tipo: TipoCaixa.CAIXA_DESPESA_FUNCIONARIO });
      this.loading = false;
    });
  }

  mapearAcoes(caixas: Caixa[]): void {
    const mapearAcoes = (caixa: Caixa): Caixa => {
      const acoes = [];
      acoes.push(CaixaDespesaFuncionarioMainComponent.IR_PARA_DETALHES_ACTION);
      return { ...caixa, acoes };
    };

    this.caixas = caixas?.map(mapearAcoes) ?? [];
  }

  onAcaoClick(event: CaixaAcaoEvent): void {
    const actions = new Map<string, (caixa: Caixa) => void>().set(
      CaixaDespesaFuncionarioMainComponent.IR_PARA_DETALHES_ACTION,
      (caixa: Caixa) => {
        this.caixaDetail(caixa);
      },
    );

    actions.get(event.acao)(event.caixa);
  }

  caixaDetail(caixa: Caixa): void {
    this.router.navigate(['base/caixas/caixa-despesa-funcionario-movimentacoes/' + caixa.id]);
  }

  onLoadCaixaPage(page: number): void {
    this.list(page);
  }

  onFilter(options: CaixaListFilterOptions): void {
    const postoId = options.postoSelecionado ? options.postoSelecionado.id : null;

    this.queryOptions.params = {
      nomeFuncionario: options.nomeFuncionario ? `${options.nomeFuncionario}` : null,
      situacao: options.situacaoCaixa?.length ? `in:${options.situacaoCaixa.join(',')}` : null,
      postoId: options.postoSelecionado ? options.postoSelecionado.id : null,
      type: `${this.type}`,
      dataInicial: options.dataInicial ? options.dataInicial.getTime() : null,
      dataFinal: options.dataFinal ? options.dataFinal.getTime() : null,
      sort: '-dataHoraAbertura',
    };
    this.router.navigate(['/base/caixas/caixa-despesa-funcionario'], {queryParams: this.queryOptions.params}).then(() => this.list());

    if (postoId !== this.postoSelecionado) {
      this.postoSelecionado = postoId;
    }
  }

  getValorTotalPorTipoCaixa(valoresCaixa: Partial<ValoresCaixaRequestDTO>): void {
    this.caixaService.getValorTotalPorTipoCaixa(valoresCaixa).subscribe((response: ReturnAPI<number>) => {
      this.totalizador = response.object || 0;
    });
  }

  generateMask(value: number): string {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  listarLancamentos(page: number = 0): void {
    this.queryOptionsLancamento.pageNumber = page;
    this.loadingLancamento = true;

    this.lancamentoDespesaService.pageAll(this.queryOptionsLancamento).subscribe(
      (response: Page<LancamentoDespesa>) => {
        this.totalRecordsLancamento = response?.totalElements ?? 0;
        this.mapearAcoesDeLancamentos(response?.content ?? []);
        this.loadingLancamento = false;
      },
      () => {
        this.lancamentos = [];
        this.loadingLancamento = false;
        this.dialogService.feedbackError('Ocorreu um erro ao listar os lançamentos de despesa!');
      },
    );

    this.lancamentoDespesaService
      .getValorTotal(this.queryOptionsLancamento)
      .subscribe((total: number) => (this.totalizadorLancamento = total || 0));
  }

  onLoadLancamentoPage(page: number): void {
    this.listarLancamentos(page);
  }

  onFiltrarLancamentos(options: LancamentoDespesaListFilterOptions): void {
    this.queryOptionsLancamento.params = {
      dataInicial: options.dataInicial ? options.dataInicial.getTime() : null,
      dataFinal: options.dataFinal ? options.dataFinal.getTime() : null,
      tipoDespesa: options.tiposDespesa?.length ? options.tiposDespesa.join(',') : null,
      categoria: options.categorias?.length ? options.categorias.join(',') : null,
      formaPagamento: options.formasPagamento?.length ? options.formasPagamento.join(',') : null,
      situacao: options.situacoes?.length ? options.situacoes.join(',') : null,
      postoId: options.postoSelecionado ? options.postoSelecionado.id : null,
      contaTevId: options.contaTevSelecionada ? options.contaTevSelecionada.id : null,
      valorMinimo: options.valorMinimo ? options.valorMinimo : null,
      valorMaximo: options.valorMaximo ? options.valorMaximo : null,
      descricao: options.descricao ? encodeURIComponent(options.descricao) : null,
    };

    this.listarLancamentos();
  }

  onAcaoLancamentoClick(event: LancamentoDespesaAcaoEvent): void {
    const actions = new Map<string, (lancamento: LancamentoDespesa) => void>()
      .set(CaixaDespesaFuncionarioMainComponent.EDITAR_LANCAMENTO_ACTION, (lancamento: LancamentoDespesa) => {
        this.abrirFormularioLancamento('editar', lancamento);
      })
      .set(CaixaDespesaFuncionarioMainComponent.PAGAR_LANCAMENTO_ACTION, (lancamento: LancamentoDespesa) => {
        this.dialogService.confirmDialog('Deseja marcar este lançamento como pago?', () => this.pagarLancamento(lancamento));
      })
      .set(CaixaDespesaFuncionarioMainComponent.CANCELAR_LANCAMENTO_ACTION, (lancamento: LancamentoDespesa) => {
        this.dialogService.confirmDialog('Deseja realmente cancelar este lançamento?', () => this.cancelarLancamento(lancamento));
      });

    actions.get(event.acao)(event.lancamento);
  }

  onNovoLancamento(): void {
    this.abrirFormularioLancamento('novo', null);
  }

  onExportarLancamentos(): void {
    this.lancamentoDespesaService.relatorio(this.queryOptionsLancamento).subscribe(
      (lancamentos: LancamentoDespesa[]) => this.baixarRelatorio(lancamentos),
      () => this.dialogService.feedbackError('Ocorreu um erro ao gerar o relatório de despesas!'),
    );
  }

  private abrirFormularioLancamento(action: string, lancamento: LancamentoDespesa): void {
    this.dialog
      .open(LancamentoDespesaFormComponent, {
        data: { action, lancamento, postos: this.postos, contas: this.contas },
        width: '700px',
      })
      .afterClosed()
      .subscribe((resultado: LancamentoDespesa) => {
        if (!resultado) {
          return;
        }

        this.lancamentoDespesaService.createOrUpdate(resultado).subscribe(
          () => {
            this.dialogService.feedbackSuccess('Operação realizada com sucesso!');
            this.listarLancamentos();
          },
          // tslint:disable-next-line: no-any
          (error: any) => {
            this.dialogService.feedbackError(error?.error ?? 'Ocorreu um erro ao salvar o lançamento de despesa!');
          },
        );
      });
  }

  private pagarLancamento(lancamento: LancamentoDespesa): void {
    this.lancamentoDespesaService.pagar(lancamento, new Date()).subscribe(
      () => {
        this.dialogService.feedbackSuccess('Operação realizada com sucesso!');
        this.listarLancamentos();
      },
      // tslint:disable-next-line: no-any
      (error: any) => this.dialogService.feedbackError(error?.error ?? 'Ocorreu um erro ao pagar o lançamento!'),
    );
  }

  private cancelarLancamento(lancamento: LancamentoDespesa): void {
    this.lancamentoDespesaService.cancelar(lancamento).subscribe(
      () => {
        this.dialogService.feedbackSuccess('Operação realizada com sucesso!');
        this.listarLancamentos();
      },
      // tslint:disable-next-line: no-any
      (error: any) => this.dialogService.feedbackError(error?.error ?? 'Ocorreu um erro ao cancelar o lançamento!'),
    );
  }

  private mapearAcoesDeLancamentos(lancamentos: LancamentoDespesa[]): void {
    const mapearAcoes = (lancamento: LancamentoDespesa): LancamentoDespesa => {
      const acoes = [];

      if (lancamento.situacao !== SituacaoLancamentoDespesa.CANCELADO) {
        acoes.push(CaixaDespesaFuncionarioMainComponent.EDITAR_LANCAMENTO_ACTION);
        acoes.push(CaixaDespesaFuncionarioMainComponent.CANCELAR_LANCAMENTO_ACTION);
      }

      if (lancamento.situacao === SituacaoLancamentoDespesa.PENDENTE) {
        acoes.push(CaixaDespesaFuncionarioMainComponent.PAGAR_LANCAMENTO_ACTION);
      }

      return { ...lancamento, acoes };
    };

    this.lancamentos = lancamentos?.map(mapearAcoes) ?? [];
  }

  private baixarRelatorio(lancamentos: LancamentoDespesa[]): void {
    if (!lancamentos?.length) {
      this.dialogService.feedbackInfo('Nenhum lançamento encontrado para os filtros informados.');
      return;
    }

    const ultimaColuna = this.colunasRelatorio.length - 1;
    const linhaTotal = lancamentos.length + 1;
    const planilha: XLSX.WorkSheet = {};

    this.colunasRelatorio.forEach((coluna: ColunaRelatorio, indiceColuna: number) => {
      this.escreverCelula(planilha, 0, indiceColuna, coluna.titulo);

      lancamentos.forEach((lancamento: LancamentoDespesa, indiceLinha: number) => {
        this.escreverCelula(planilha, indiceLinha + 1, indiceColuna, coluna.valor(lancamento), coluna.formato);
      });

      if (coluna.somar) {
        const total = lancamentos.reduce((soma: number, lancamento: LancamentoDespesa) => soma + (lancamento.valor ?? 0), 0);
        this.escreverCelula(planilha, linhaTotal, indiceColuna, total, coluna.formato);
      }
    });

    this.escreverCelula(planilha, linhaTotal, 0, 'TOTAL');

    planilha['!ref'] = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: linhaTotal, c: ultimaColuna } });
    planilha['!cols'] = this.colunasRelatorio.map((coluna: ColunaRelatorio) => ({ wch: coluna.largura }));
    // O filtro cobre apenas cabeçalho e dados, deixando a linha de total de fora.
    planilha['!autofilter'] = {
      ref: XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: lancamentos.length, c: ultimaColuna } }),
    };

    const arquivo = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(arquivo, planilha, 'Lançamentos de Despesa');

    const conteudo = XLSX.write(arquivo, { bookType: 'xlsx', type: 'array' });

    FileSaver.saveAs(
      new Blob([conteudo], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
      `lancamentos-despesa-${new Date().getTime()}.xlsx`,
    );
  }

  /**
   * Grava a célula com o tipo nativo do Excel (data, número ou texto) para que a
   * planilha saia com as colunas alinhadas e os valores somáveis.
   */
  private escreverCelula(
    planilha: XLSX.WorkSheet,
    linha: number,
    coluna: number,
    valor: string | number | Date,
    formato?: string,
  ): void {
    if (valor === null || valor === undefined || valor === '') {
      return;
    }

    let celula: XLSX.CellObject;

    if (valor instanceof Date) {
      celula = { t: 'd', v: valor };
    } else if (typeof valor === 'number') {
      celula = { t: 'n', v: valor };
    } else {
      celula = { t: 's', v: `${valor}` };
    }

    if (formato) {
      celula.z = formato;
    }

    planilha[XLSX.utils.encode_cell({ r: linha, c: coluna })] = celula;
  }

  private descricaoContaTev(conta: ContaTev): string {
    return conta ? `${conta.identificador} - Ag. ${conta.agencia} / C. ${conta.conta}` : '';
  }

  /**
   * Converte a data para o número de série do Excel (dias inteiros desde
   * 30/12/1899). O cálculo é feito na mão, em UTC, porque a conversão
   * automática do SheetJS aplica a diferença de fuso entre hoje e 1899 e
   * devolve um valor quebrado, que o Excel exibe como o dia anterior.
   */
  private paraSerialDoExcel(data: Date): number | string {
    if (!data) {
      return '';
    }

    const convertida = new Date(data);

    if (isNaN(convertida.getTime())) {
      return '';
    }

    const dias =
      Date.UTC(convertida.getFullYear(), convertida.getMonth(), convertida.getDate()) - Date.UTC(1899, 11, 30);

    return dias / CaixaDespesaFuncionarioMainComponent.MILISSEGUNDOS_POR_DIA;
  }

  private listarPostos(): void {
    this.postoService.listarPostos().subscribe((response: ReturnAPI<Posto[]>) => {
      this.postos = response?.success ? response.object : [];
    });
  }

  private listarContas(): void {
    this.contaTevService.list(new QueryOptions({ pageSize: 100 })).subscribe((contas: ContaTev[]) => {
      this.contas = contas ?? [];
    });
  }
}
